import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';

import { Types, Creators } from 'store/ducks/page';
import { callApi } from 'store/sagas/auth';

import { push } from 'connected-react-router';
import Notifications from 'react-notification-system-redux';

function* getPage({ payload }) {
  try {
    const { id } = payload;
    const response = yield call(api.get, `/v1/admin/pages/${id}`);
    yield put(Creators.getPageSuccess(response.data));
  } catch (err) {
    yield put(Creators.getPageFailure('Erro ao buscar na API'));
  }
}

const readFile = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });

function* getPageImageUpload(payload) {
  try {
    const { id, image_data } = payload;
    const imageBase64 = yield call(readFile, image_data);
    const data = {
      image: imageBase64,
    };
    const response = yield call(api.post, `/v1/admin/pages/${id}/image`, data);
    return true;
  } catch (err) {
    return false;
  }
}
function* getPageInsert({ payload }) {
  try {
    const {
      name,
      description,
      image_data,
      seo_title,
      seo_word_key,
      seo_description,
    } = payload;
    const response = yield call(api.post, '/v1/admin/pages', {
      name,
      description,
      seo_title,
      seo_word_key,
      seo_description,
    });
    const { id } = response.data.data;

    if (typeof image_data === 'object' && image_data instanceof File) {
      yield getPageImageUpload({ id, image_data });
    }
    yield put(Creators.getPageInsertSuccess());
    yield put(
      Notifications.success({ title: 'Cadastro concluido com sucesso' }),
    );

    yield put(push(`/pages/update/${id}`));
  } catch (err) {
    yield put(Creators.getPageInsertFailure('Erro ao buscar na API'));
  }
}

function* getPageUpdate({ payload }) {
  try {
    const {
      id,
      name,
      description,
      image_data,
      seo_title,
      seo_word_key,
      seo_description,
    } = payload;
    const response = yield call(api.put, `/v1/admin/pages/${id}`, {
      name,
      description,
      seo_title,
      seo_word_key,
      seo_description,
    });
    if (typeof image_data === 'object' && image_data instanceof File) {
      yield getPageImageUpload({ id, image_data });
    }
    yield put(Creators.getPageUpdateSuccess());
    yield put(Notifications.success({ title: 'Edição concluida com sucesso' }));
    yield put(Creators.getPageListRequest());
    yield put(push(`/pages/update/${id}`));
  } catch (err) {
    yield put(Creators.getPageUpdateFailure('Erro ao buscar na API'));
  }
}

function* getPageDelete({ payload }) {
  try {
    const { id } = payload;
    const response = yield call(api.delete, `/v1/admin/pages/${id}`);
    yield put(Creators.getPageDeleteSuccess());
    // Remove a categoria deletada da lista
    const { pageList, pageListTotal } = yield select(state => state.page);

    yield put(
      Creators.getPageListSuccess({
        data: pageList.filter(doc => doc.id !== id),
        total: pageListTotal - 1,
      }),
    );
  } catch (err) {
    yield put(Creators.getPageDeleteFailure('Erro ao buscar na API'));
  }
}

function* getPageList({ payload }) {
  try {
    const { page, perPage, search, orderByColumn, orderByDirection } = payload;
    const request = call(api.get, '/v1/admin/pages', {
      page,
      search,
      per_page: perPage,
      order: orderByColumn,
      order_by: orderByDirection,
    });

    const response = yield call(callApi, request);
    yield put(Creators.getPageListSuccess(response.data));
  } catch (err) {
    if (err.status === 404) {
      yield put(
        Creators.getPageListSuccess({
          total: 0,
          data: [],
        }),
      );
    } else {
      yield put(Creators.getPageListFailure('Erro ao buscar na API'));
    }
    yield put(Notifications.error({ title: err.data.msg }));
  }
}

function* getImagePageDelete({ payload }) {
  try {
    const { id, id_page } = payload;
    const request = yield call(
      api.delete,
      `/v1/admin/pages/${id_page}/image/${id}`,
    );
    const response = yield call(callApi, request);
    yield put(Creators.getImagePageDeleteSuccess());
  } catch (err) {
    yield put(Creators.getImagePageDeleteFailure('Erro ao buscar na API'));
  }
}

// Individual exports for testing
export default function* productListSaga() {
  yield all([
    takeLatest(Types.GET_REQUEST, getPage),
    takeLatest(Types.GET_INSERT_REQUEST, getPageInsert),
    takeLatest(Types.GET_UPDATE_REQUEST, getPageUpdate),
    takeLatest(Types.GET_DELETE_REQUEST, getPageDelete),
    takeLatest(Types.GET_LIST_REQUEST, getPageList),
    takeLatest(Types.GET_IMAGE_DELETE_REQUEST, getImagePageDelete),
  ]);
}
